import { useHistory } from "react-router-dom";

import Answer from "../components/Answer";
// IMPORT SVG
import { ReactComponent as ChevronLeft } from "../assets/feathericons/chevron-left.svg";
import { ReactComponent as Check } from "../assets/feathericons/check.svg";
import { ReactComponent as Trash } from "../assets/feathericons/trash.svg";

const TopForm = ({ data, handleSubmit, handleDeleteForm, name, setName }) => {
  const history = useHistory();

  return (
    <div className="top-screen">
      <div className="my-forms">
        <ChevronLeft />
        {/* go home */}
        <p
          onClick={() => {
            history.push("/");
          }}
        >
          Mes formulaires
        </p>
      </div>

      {/* input name top */}
      <div className="row">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Titre du formulaire"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
          <button type="submit" className="check">
            <Check style={{ height: 18 }} />
          </button>
        </form>
      </div>

      <div className="row">
        <form onSubmit={handleDeleteForm}>
          <button type="submit" className="trash">
            <Trash style={{ height: 15 }} />
          </button>
        </form>
        <Answer data={data} />
      </div>
    </div>
  );
};
export default TopForm;
